var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("page", [
    _c("div", { staticClass: "page-title" }, [_vm._v("出入款管理")]),
    _c(
      "div",
      { staticClass: "page-content", staticStyle: { padding: "0" } },
      [
        _c(
          "el-tabs",
          {
            model: {
              value: _vm.activeTab,
              callback: function ($$v) {
                _vm.activeTab = $$v
              },
              expression: "activeTab",
            },
          },
          [
            _c(
              "el-tab-pane",
              { attrs: { label: "三方入款管理", name: "payin" } },
              [
                _c("ManagePayinChannelTab", {
                  on: { update: _vm.handleUpdate },
                }),
              ],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "三方出款管理", name: "payout" } },
              [
                _c("ManagePayoutChannelTab", {
                  on: { update: _vm.handleUpdate },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }